import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../config/axiosClient";

export default function FeedbackButton() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [website, setWebsite] = useState(""); // honeypot
  const [status, setStatus] = useState(null);

  // Hide on project detail pages — speed dial there includes feedback
  if (/^\/projects\/\d+$/.test(location.pathname)) return null;

  const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  const canSubmit = name.trim() && message.trim() && isValidEmail(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setStatus("sending");
    try {
      await axios.post("https://api.inertia7.com/api/v1/feedback/", {
        name,
        email,
        message,
        website,
        page: window.location.pathname,
      });
      setStatus("success");
      setName("");
      setEmail("");
      setMessage("");
      setTimeout(() => { setOpen(false); setStatus(null); }, 2000);
    } catch (err) {
      setStatus(err.response?.status === 429 ? "rate-limited" : "error");
    }
  };

  return (
    <>
      {/* Floating trigger */}
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: "fixed", bottom: 20, left: 20, zIndex: 1000,
          width: 44, height: 44, borderRadius: "50%",
          border: "none", background: "var(--brand, #59c6c1)", color: "#fff",
          fontSize: 18, cursor: "pointer",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          display: "flex", alignItems: "center", justifyContent: "center",
          transition: "transform 150ms ease",
          transform: open ? "rotate(45deg)" : "none",
        }}
        title="Send feedback"
      >
        {open ? "+" : "?"}
      </button>

      {/* Feedback panel */}
      {open && (
        <div style={{
          position: "fixed", bottom: 76, left: 20, zIndex: 1000,
          width: 320, background: "var(--surface, #fff)",
          border: "1px solid var(--border, #ddd)", borderRadius: 10,
          boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          padding: 16,
        }}>
          {status === "success" ? (
            <p style={{ fontSize: 14, fontWeight: 600, textAlign: "center", margin: "12px 0", color: "var(--brand)" }}>
              Thanks for the feedback!
            </p>
          ) : (
            <form onSubmit={handleSubmit}>
              <p style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>
                Send Feedback
              </p>
              <input
                type="text"
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{
                  width: "100%", padding: "8px 10px", marginBottom: 8,
                  border: "1px solid var(--border)", borderRadius: 6,
                  background: "var(--bg-soft, #f5f5f5)", color: "var(--ink)",
                  fontSize: 13, fontFamily: "inherit",
                  boxSizing: "border-box",
                }}
              />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: "100%", padding: "8px 10px", marginBottom: 8,
                  border: "1px solid var(--border)", borderRadius: 6,
                  background: "var(--bg-soft, #f5f5f5)", color: "var(--ink)",
                  fontSize: 13, fontFamily: "inherit",
                  boxSizing: "border-box",
                }}
              />
              {/* Honeypot */}
              <div style={{ position: "absolute", left: "-9999px" }} aria-hidden="true">
                <input
                  type="text"
                  name="website"
                  tabIndex={-1}
                  autoComplete="off"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                />
              </div>
              <textarea
                placeholder="Bug report, feature request, or general feedback..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                rows={4}
                maxLength={5000}
                style={{
                  width: "100%", padding: "8px 10px", marginBottom: 8,
                  border: "1px solid var(--border)", borderRadius: 6,
                  background: "var(--bg-soft, #f5f5f5)", color: "var(--ink)",
                  fontSize: 13, fontFamily: "inherit", resize: "vertical",
                  boxSizing: "border-box",
                }}
              />
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <span style={{ fontSize: 11, color: "var(--muted)" }}>
                  {message.length}/5000
                </span>
                <button
                  type="submit"
                  disabled={status === "sending" || !canSubmit}
                  style={{
                    padding: "6px 18px", border: "none", borderRadius: 5,
                    background: "var(--brand, #59c6c1)", color: "#fff",
                    fontSize: 13, fontWeight: 600,
                    cursor: status === "sending" || !canSubmit ? "not-allowed" : "pointer",
                    opacity: status === "sending" || !canSubmit ? 0.6 : 1,
                  }}
                >
                  {status === "sending" ? "..." : "Send"}
                </button>
              </div>
              {status === "error" && (
                <p style={{ color: "var(--danger, #ef4444)", fontSize: 12, marginTop: 6 }}>
                  Something went wrong. Try again.
                </p>
              )}
              {status === "rate-limited" && (
                <p style={{ color: "var(--danger, #ef4444)", fontSize: 12, marginTop: 6 }}>
                  Please wait a minute before sending again.
                </p>
              )}
            </form>
          )}
        </div>
      )}
    </>
  );
}
